import { render, staticRenderFns } from "./HistoryNav.vue?vue&type=template&id=42a21edc&scoped=true&"
import script from "./HistoryNav.vue?vue&type=script&lang=js&"
export * from "./HistoryNav.vue?vue&type=script&lang=js&"
import style0 from "./HistoryNav.vue?vue&type=style&index=0&id=42a21edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a21edc",
  null
  
)

export default component.exports